
import { combineReducers } from "redux";
// import loadingReducer from "./loadingReducer";
import loadingSlice from './loadingSlice';
import redirectreducer from "./redirectreducer"
import clientSlice from "./clientSlice"
import RegionSlice  from "./RegionSlice";
import clientEntitySlice  from "./clientEntitySlice";
import MonthSlice  from "./MonthSlice";
import WholeGroupSlice  from "./WholeGroupSlice";
import louSlice  from "./LouSlice";


const rootReducer = combineReducers({
  // isLoading: loadingReducer,
  redirect: redirectreducer,
  client: clientSlice,
  loader: loadingSlice,
  region: RegionSlice,
  clientEntity:clientEntitySlice,
  month:MonthSlice,
  wholegroup:WholeGroupSlice,
  lou:louSlice

});

export default rootReducer;
export type RootState = ReturnType<typeof rootReducer>;

